// rankingSlice.js - FIXED version

import { createSlice } from '@reduxjs/toolkit';

const rankingSlice = createSlice({
  name: 'ranking',
  initialState: {
    activeBatches: [],
    leaderboard: {},
    nextBatches : [],
    topLeader:{},
    error: null,
  },
  reducers: {
    setActiveBatches: (state, action) => {
      state.activeBatches = action.payload;
    },
    setLeaderboard: (state, action) => {
      state.leaderboard = action.payload;
    },
    setTopLeader: (state, action) => {
      state.topLeader = action.payload;
    },
    setNextBatch : (state, action)=>{
      state.nextBatches = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setActiveBatches,
  setLeaderboard,
  setTopLeader,
  setNextBatch,
  setError,
  clearError,
} = rankingSlice.actions;

export default rankingSlice.reducer;